import { createAsyncThunk } from '@reduxjs/toolkit';

// A small, self-contained thunk used only for the live keyword-search dropdown
// on the homepage SearchCTA section. Scoped locally to this component so it
// never touches SearchPage's own Redux state, or the Topbar's separate copy
// of this same pattern.
export const searchKeywordSuggestions = createAsyncThunk(
  'FilterKeyword/searchKeywordSuggestions',
  async ({ keywords, perPage = 6 }, thunkAPI) => {
    const sdk = thunkAPI.extra;
    const response = await sdk.listings.query({
      keywords,
      perPage,
      'fields.listing': ['title'],
    });
    return response.data.data;
  }
);
